<script>
import Layout from "@layouts/form";
import ContratoAditivo from "@forms/ContratoAditivo";

export default {
  page: {
    title: "Detalhes | Contrato Aditivo"
  },
  components: { Layout, ContratoAditivo },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Contrato Aditivo",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Contrato Aditivo",
          href: "/ContratoAditivo"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <ContratoAditivo :editable="editable"></ContratoAditivo>
    </div>
  </Layout>
</template>
